import styled from "styled-components";

export const LoginTemplate = styled.div`
  gap: 40px;
  height: 100%;
  display: flex;
  overflow: auto;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const LogoBox = styled.div`
  gap: 6px;
  color: ${(props) => props.theme.colors.text3};
  display: flex;
  font-size: 1.8rem;
  flex-shrink: 0;
  font-weight: 600;
  align-items: center;
  margin-bottom: 10px;
  flex-direction: column;
  justify-content: center;
`;

export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
`;

export const Separator = styled.div`
  width: 1px;
  height: 20px;
  margin: 0 3px;
  background-color: ${(props) => props.theme.colors.black10};
`;
